/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    header: 'Management',
    icon: 'PackageIcon',
    i18n: 'Apps',
    items: [
      {
        url: null,
        name: 'Lao Chaiyaburi',
        icon: 'FileTextIcon',
        slug: 'app-Chaiyaburi',
        i18n: 'appChaiyaburi',
        submenu: [
          {
            url: '/chaiyaburi',
            name: 'ข้อมูลหวย',
            icon: 'UserIcon',
            slug: 'app-laos-list',
            i18n: 'Chaiyaburi',
          },
        ]
      },
      {
        url: null,
        name: 'Lao Udomchai',
        icon: 'FileTextIcon',
        slug: 'app-Salavan',
        i18n: 'appSalavan',
        submenu: [
          {
            url: '/udomchai',
            name: 'ข้อมูลหวย',
            icon: 'UserIcon',
            slug: 'app-laos-list',
            i18n: 'udomchai',
          },
          // {
          //   url: '/management/banner1',
          //   name: 'ข้อมูลโฆษณา',
          //   icon: 'SunIcon',
          //   slug: 'app-ads-list',
          //   i18n: 'Users',
          // },
          // {
          //   url: '/management/background1',
          //   name: 'ภาพพื้นหลัง',
          //   icon: 'SunIcon',
          //   slug: 'app-ads-list',
          //   i18n: 'Users',
          // },
        ]
      },
      {
        url: null,
        name: 'Lao LuangNamtha',
        icon: 'FileTextIcon',
        slug: 'app-LuangNamtha',
        i18n: 'appLuangNamtha',
        submenu: [
          {
            url: '/luangnamtha',
            name: 'ข้อมูลหวย',
            icon: 'UserIcon',
            slug: 'app-laos-list',
            i18n: 'luangnamtha',
          },
        ]
      },
      {
        url: null,
        name: 'Lao Chaisomboon',
        icon: 'FileTextIcon',
        slug: 'app-Chaisomboon',
        i18n: 'appChaisomboon',
        submenu: [
          {
            url: '/chaisomboon',
            name: 'ข้อมูลหวย',
            icon: 'UserIcon',
            slug: 'app-chaisomboon-list',
            i18n: 'Chaisomboon',
          },
        ]
      },
      {
        url: '/lao-chow',
        name: 'Lao Chow',
        icon: 'FileTextIcon',
        slug: 'app-lao-chow',
        i18n: 'appstarextra',
      },
      {
        url: '/starextra',
        name: 'Lao StarExtra',
        icon: 'FileTextIcon',
        slug: 'app-starextra',
        i18n: 'appstarextra',
      },
      {
        url: '/laohd',
        name: 'Laos HD',
        icon: 'FileTextIcon',
        slug: 'app-laohd',
        i18n: 'applaohd',
      },
      {
        url: '/laoasean',
        name: 'Laos Asean',
        icon: 'FileTextIcon',
        slug: 'app-laoasean',
        i18n: 'applaoasean',
      },
      {
        url: '/laosnight',
        name: 'Laos Night',
        icon: 'FileTextIcon',
        slug: 'app-Night',
        i18n: 'appNight',
      },
      {
        url: '/laogrowextra',
        name: 'Laosพัฒนา (EXTRA)',
        icon: 'FileTextIcon',
        slug: 'app-laogrowextra',
        i18n: 'applaoasean',
      },
      {
        url: '/laoextra',
        name: 'Laos (EXTRA) พิเศษ',
        icon: 'FileTextIcon',
        slug: 'app-laoextra',
        i18n: 'applaoextra',
      },
      {
        url: '/laopatuchai',
        name: 'Laos ประตูชัย',
        icon: 'FileTextIcon',
        slug: 'app-laopatuchai',
        i18n: 'applaoextra',
      },
      {
        url: '/laosantipap',
        name: 'Laos สันติภาพ',
        icon: 'FileTextIcon',
        slug: 'app-laosantipap',
        i18n: 'applaoextra',
      },
      {
        url: '/laopachachon',
        name: 'Laos ประชาชน',
        icon: 'FileTextIcon',
        slug: 'app-laopachachon',
        i18n: 'applaoextra',
      },
      {
        url: null,
        name: 'Hanoi(4K)',
        icon: 'FileTextIcon',
        slug: 'app-report',
        i18n: 'Report',
        submenu: [
          {
            url: '/hanoi',
            name: 'ข้อมูลหวย',
            icon: 'UserIcon',
            slug: 'app-laos-list',
            i18n: 'Hanoi',
          },
        ]
      },
      {
        url: '/hanoi5g',
        name: 'Hanoi(5G)',
        icon: 'FileTextIcon',
        slug: 'app-hanoi5g',
        i18n: 'apphanoi5g',
      },
      {
        url: '/hanoivip',
        name: 'Hanoi(VIP)',
        icon: 'FileTextIcon',
        slug: 'app-hanoinvip',
        i18n: 'apphanoinvip',
      },
      {
        url: '/hanoiextra',
        name: 'Hanoi(EXTRA)',
        icon: 'FileTextIcon',
        slug: 'app-hanoinextra',
        i18n: 'apphanoinextra',
      },
      {
        url: '/hanoiasean',
        name: 'Hanoi(Asean)',
        icon: 'FileTextIcon',
        slug: 'app-hanoiAsean',
        i18n: 'apphanoiAsean',
      },
      {
        url: '/hanoisamakkhi',
        name: 'Hanoi(Samakkhi)',
        icon: 'FileTextIcon',
        slug: 'app-hanoiSamakkhi',
        i18n: 'apphanoiSamakkhi',
      },
      {
        url: '/hanoistarextra',
        name: 'Hanoi(StarExtra)',
        icon: 'FileTextIcon',
        slug: 'app-hanoistarextra',
        i18n: 'apphanoistarextra',
      },
      {
        url: '/hanoinight',
        name: 'Hanoi(Night)',
        icon: 'FileTextIcon',
        slug: 'app-hanoinight',
        i18n: 'apphanoinight',
      },
      {
        url: '/hanoi-special',
        name: 'Hanoi(Special)',
        icon: 'FileTextIcon',
        slug: 'app-hanoi-special',
        i18n: 'apphanoi-special',
      },
      {
        url: '/nikkei',
        name: 'Nikkei-Meta',
        icon: 'FileTextIcon',
        slug: 'app-nikkei',
        i18n: 'appnikkei',
      },
      {
        url: '/chinese',
        name: 'SZSE-Meta',
        icon: 'FileTextIcon',
        slug: 'app-SZSE',
        i18n: 'appSZSE',
      },
      {
        url: '/tokyo',
        name: 'Tokyo',
        icon: 'FileTextIcon',
        slug: 'app-tokyo',
        i18n: 'apptokyo',
      },
      {
        url: '/hangseng',
        name: 'Hangseng-Meta',
        icon: 'FileTextIcon',
        slug: 'app-Hangseng',
        i18n: 'appHangseng',
      },
      {
        url: '/ktop',
        name: 'KTOP Meta 30',
        icon: 'FileTextIcon',
        slug: 'app-KTOP',
        i18n: 'appKTOP',
      },
      
      {
        url: '/palm',
        name: 'Oil palm + Features Price',
        icon: 'FileTextIcon',
        slug: 'app-palm',
        i18n: 'apppalm',
      },
      {
        url: '/redcross',
        name: 'Lao Red Cross VIP',
        icon: 'FileTextIcon',
        slug: 'app-redcross',
        i18n: 'appredcross',
      },
      {
        url: '/lao12zodiac',
        name: 'Lao 12 Zodiac',
        icon: 'FileTextIcon',
        slug: 'app-lao12zodiac',
        i18n: 'lao12zodiac',
      },
      {
        url: '/hanoitravel',
        name: 'Hanoi Travel',
        icon: 'FileTextIcon',
        slug: 'app-hanoitravel',
        i18n: 'apphanoitravel',
      },
      {
        url: '/btc',
        name: 'BTC',
        icon: 'FileTextIcon',
        slug: 'app-btc',
        i18n: 'appbtc',
      },
      {
        url: '/ftse',
        name: 'Ftse-VIP2',
        icon: 'FileTextIcon',
        slug: 'app-Ftse',
        i18n: 'appFtse',
      },
      {
        url: '/dax',
        name: 'Dax-VIP2',
        icon: 'FileTextIcon',
        slug: 'app-dax',
        i18n: 'appdax',
      },
      {
        url: '/moexbluechip',
        name: 'Moexbluechip-VIP2',
        icon: 'FileTextIcon',
        slug: 'app-moexbluechip',
        i18n: 'appmoexbluechip',
      },
      {
        url: '/dowjones',
        name: 'Dowjones Meta',
        icon: 'FileTextIcon',
        slug: 'app-dowjones',
        i18n: 'appdowjones',
      },
      {
        url: '/dowjones-specialone',
        name: 'Dowjones Specialone',
        icon: 'FileTextIcon',
        slug: 'app-dowjones-specialone',
        i18n: 'appdowjones-specialone',
      },
      {
        url: '/dowjones-extraspecial',
        name: 'Dowjones ExtraSpecial',
        icon: 'FileTextIcon',
        slug: 'app-dowjones-extraspecial',
        i18n: 'appdowjones-extraspecial',
      },
      {
        url: '/dowjones-starspecial',
        name: 'Dowjones StarSpecial',
        icon: 'FileTextIcon',
        slug: 'app-dowjones-starspecial',
        i18n: 'appdowjones-starspecial',
      },
      {
        url: '/malay-dragon',
        name: 'Malay Dragon',
        icon: 'FileTextIcon',
        slug: 'app-malay-dragon',
        i18n: 'malay-dragon',
      },
      {
        url: '/malay-special',
        name: 'Malay Special',
        icon: 'FileTextIcon',
        slug: 'app-malay-special',
        i18n: 'malay-special',
      },
    ]
  },
]
